import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { Observable } from 'rxjs/Observable';
import { ModalController, NavParams } from 'ionic-angular';
import { SPHUser } from './../../shared/model/sph-user.model';
import { Component, OnInit, Input } from '@angular/core';
import { SPHLoggedInUser, LicenseManagerService } from '../../shared/shared';
import { UserDetailsComponent } from '../userDetailsComponent/user-details.component';

@Component({
    selector: 'users-component',
    templateUrl: 'users.component.html'
})

export class UsersComponent {
    private _user: SPHLoggedInUser;
    @Input() set user(user: SPHLoggedInUser) {
        this._user = user;
        this.reloadUsers();
    }
    get user(): SPHLoggedInUser {
        return this._user;
    }

    private _users: SPHUser[];
    @Input() set users(users: SPHUser[]) {
        this._users = users;
    }
    get users(): SPHUser[] {
        return this._users;
    }

    private displayedUsers: SPHUser[] = [];

    constructor(private modalController: ModalController, private licenseManagerService: LicenseManagerService, private navParams: NavParams, private toastController: ToastController) {
        this.user = navParams.get('user');
    }

    private reloadUsers() {
        if (this.user !== undefined) {
            this.licenseManagerService.getUsers(this.user.jwt).subscribe((users) => {
                this.updateDisplayedUsers(users);
            }, this.licenseManagerService.handleHttpError('Fehler beim Abrufen der Nutzer'));
        }
    }

    private updateDisplayedUsers(users: SPHUser[], searchText?: string, scope: string = 'all', sorting: string = 'id', asc: boolean = true) {
        this.displayedUsers = users
            .filter(this.filterFunctionFrom(searchText, scope))
            .filter( (user) => user.role >= 3 )
            .sort((a: SPHUser, b: SPHUser) => {
                if (a[sorting] < b[sorting]) {
                    return asc ? -1 : 1;
                } else if (a[sorting] > b[sorting]) {
                    return asc ? 1 : -1;
                }
                return 0;
            });

    }

    private filterFunctionFrom(text: string, scope: string) {
        if (text === '' || text === undefined) {
            return () => true;
        } else {
            text = text.toLowerCase();
            return (company: SPHUser) => {
                if (scope === 'all') {
                    return (company.username !== undefined && company.username.toLowerCase().includes(text)); // || (company.location !== undefined && company.location.toLowerCase().includes(text)) || (company.identnr !== undefined && company.identnr.includes(text))
                } else {
                    return company[scope] !== undefined && company[scope].toLowerCase().includes(text);
                }
            };
        }
    }

    private didTapDeleteUser(user: SPHUser) {
        this.licenseManagerService.deleteUser(user, this.user.jwt).subscribe((results) => {
            setTimeout( () => { this.reloadUsers(); }, 500);
            const toast = this.toastController.create({message: 'Nutzer gelöscht', duration: 3000});
            toast.present();
        }, this.licenseManagerService.handleHttpError('Fehler löschen des Nutzers'));
    }

    private didTapUser(user: SPHUser) {
        const userModal = this.modalController.create(UserDetailsComponent, { user, loggedinUser: this.user }, {enableBackdropDismiss: false});
        userModal.onDidDismiss( () => {
            this.reloadUsers();
        });

        userModal.present();
    }

    private didTapAddUser() {
        const user = new SPHUser();

        const userModal = this.modalController.create(UserDetailsComponent, { user, loggedinUser: this.user }, {enableBackdropDismiss: false});
        userModal.onDidDismiss( () => {
            this.reloadUsers();
        });

        userModal.present();
    }
}



// WEBPACK FOOTER //
// ./src/app/features/userManagement/usersComponent/users.component.ts